import tripEvents from './../../config/events.constant';

export default function TripDetailsReviewController(
    $scope,
    $state,
    $stateParams,
    tripId,
    l10nService,
    modalService,
    tripAPI,
    ktAlert,
    userService
) {
    'ngInject';

            const quoteReviewDefault = {
                    TripId: tripId,
                    ReviewerContactIds: [],
                    ReviewerEmailAddresses: [],
                    CCContactIds: [],
                    CCEmailAddresses: [],
                    CoverNote: '',
                };
            const quoteDefault = {
                    coverNote: '',
                    reviewerData: {},
                    emailsList: [],
                    markAsCC: false,
                };
            const reviewerError = {
                    isListEmpty: false,
                    emptyContact: false,
                    duplicate: false,
                };

            $scope.reviewData = {
                markAsCC: false,
            };

            $scope.quote = angular.copy(quoteDefault);
            $scope.reviewerError = angular.copy(reviewerError);
            $scope.personsToReview = [];

            $scope.isContactSelected = isContactSelected;
            $scope.removeReviewError = removeReviewError;
            $scope.onReviewerEmailSelect = onReviewerEmailSelect;

            $scope.quote.emailsList = getRecipientsFromReviews($scope.tripDetails.ReviewTripInfo.FeedbackReviews);

            $scope.addReviewer = function(contactData) {
                let personToSend = {};

                $scope.reviewerError = angular.copy(reviewerError);

                if (!contactData) {
                    $scope.reviewerError.emptyContact = true;
                    return false;
                }

                if (contactData.ContactId) {
                    personToSend = {
                        EmailAddress: contactData.EmailAddress,
                        ContactId: contactData.ContactId,
                        IsCC: $scope.reviewData.markAsCC,
                    };
                } else {
                    personToSend = {
                        EmailAddress: contactData,
                        IsCC: $scope.reviewData.markAsCC,
                    };
                }

                /**
                 * Skip if already present in list
                 */
                if (isPresentInMailsList($scope.quote, personToSend)) {
                    $scope.reviewerError.duplicate = true;
                    $scope.quote.reviewerData = {};

                    return false;
                }

                /**
                 * Skip if already present in list
                 */
                if (isSendToHimself(personToSend)) {
                    $scope.reviewerError.sendToYourself = true;
                    $scope.quote.reviewerData = {};
                    return false;
                }

                /**
                 * Clear Field with data
                 */
                $scope.reviewerError.duplicate = angular.copy(reviewerError.duplicate);
                $scope.quote.reviewerData = {};

                /**
                 * Add data to emails list
                 */
                $scope.quote.emailsList.push(personToSend);

                function isSendToHimself(recipient) {
                    return userService.getUser().Email === recipient.EmailAddress;
                }
            };

            $scope.clearRecipients = function() {
                $scope.quote.emailsList = [];
            };

            $scope.sendQuoteForReview = function(form) {
                checkQuoteFormAndSendRequest(form, true, showSentForReviewAlert);

                function showSentForReviewAlert() {
                    ktAlert.success(l10nService.localize('Verification request sent'));
                    $scope.toggleReviewBlock();
                }
            };

            $scope.cancelSendQuote = function() {
                $scope.toggleSendBlock();

                $scope.quoteReview.$setPristine();
                $scope.quoteReview.$setValidity();

                /**
                 * Reset default objects
                 */
                $scope.quote = angular.copy(quoteDefault);
                $scope.quoteReview.reviewerContacts.$setViewValue(undefined);
                $scope.quoteReview.reviewerContacts.$render();

                /**
                 * Clear forms
                 */
                $scope.reviewerError = angular.copy(reviewerError);
            };

            $scope.getPersons = function(data) {
                if (data && data.length < 3) {
                    return false;
                }

                return tripAPI.getPersonsToReview({searchString: data}).then(function(response) {
                    return _.map(response.data, function(item) {
                        item.title = item.Name + ' (' + item.EmailAddress + ')';
                        return item;
                    });
                });
            };

            $scope.removeReviewer = function($index) {
                const emailsList = $scope.quote.emailsList;

                emailsList[$index] = null;
                $scope.quote.emailsList = _.compact(emailsList);
            };

            function getRecipientsFromReviews(feedbackReviews) {
                const lastReview = _.first(feedbackReviews);
                return getRecipientsFromBackendResponse(lastReview);

                function getRecipientsFromBackendResponse(feedbackReview) {
                    const getReviewersData = _.partialRight(_.pick, ['ContactId', 'EmailAddress', 'IsCC']);
                    const reviewersFromReviewData = _.chain(feedbackReview)
                        .get('Recipients')
                        .map(getReviewersData)
                        .value();
                    return reviewersFromReviewData;
                }
            }

            function onReviewerEmailSelect(quoteReview) {
                quoteReview.reviewerContacts.$setValidity('pattern', true);
            }

            function checkQuoteFormAndSendRequest(form, sendQuoteForReview, callback) {
                if (checkQuoteFormValidity(form)) {
                    const quoteRequestData = getQuoteRequest($scope.quote);
                    quoteRequestData.IsNeedFeedback = !!sendQuoteForReview;
                    sendQuoteToBE(quoteRequestData, callback);
                }
            }

            function isPresentInMailsList(quote, personToSend) {
                let result = false;
                _.each(quote.emailsList, function(email) {
                    result = result || _.contains(email, personToSend.EmailAddress);
                });
                return result;
            }

            function getQuoteRequest(quote) {
                const quoteReview = angular.copy(quoteReviewDefault);

                _.each(quote.emailsList, function(quoteItem) {
                    const contact = (quoteItem.ContactId) ? quoteItem.ContactId : quoteItem.EmailAddress;

                    if (quoteItem.ContactId) {

                        if (quoteItem.IsCC) {
                            quoteReview.CCContactIds.push(contact);
                        } else {
                            quoteReview.ReviewerContactIds.push(contact);
                        }

                    } else if (quoteItem.IsCC) {
                            quoteReview.CCEmailAddresses.push(contact);
                        } else {
                            quoteReview.ReviewerEmailAddresses.push(contact);
                        }
                });

                quoteReview.CoverNote = quote.coverNote;

                return quoteReview;
            }

            function checkQuoteFormValidity(form) {
                if (form.$invalid) {
                    return false;
                }

                if (!_.filter($scope.quote.emailsList, (email) => !email.IsCC).length) {
                    $scope.reviewerError.isListEmpty = true;
                    return false;
                }

                return true;
            }

            function sendQuoteToBE(quoteReview, callback) {
                tripAPI.sendQuote(quoteReview)
                    .then(() => {
                    if (callback) {
                        callback();
                    }

                    $scope.reviewerError = angular.copy(reviewerError);
                    $scope.$emit(tripEvents.TRIP_DETAILS_UPDATE);
                });
            }

            function isContactSelected() {
                return angular.isObject($scope.quote.reviewerData.personTitle);
            }

            function removeReviewError() {
                $scope.reviewerError = angular.copy(reviewerError);
            }

}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/details/tripDetailsReviewController.js